import { Link } from "react-router-dom";

function Section({ Image, text }) {
  return (
    <Link className='item'>
      <img src={Image} />
      <p>{text}</p>
    </Link>
  )
}
export default Section;